import {Outlet} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {StartFreeToday} from '../landing/components/StartFreeToday'
import {SeoHead} from '../../modules/seo'

export function ReleasesLayout() {
  const intl = useIntl()

  return (
    <PublicWrapper>
      <SeoHead />
      <section className='releases-header'>
        <div className='releases-header-container'>
          <h1 className='releases-header-title'>{intl.formatMessage({id: 'RELEASES_TITLE'})}</h1>
        </div>
      </section>

      <section className='releases-hero'>
        <div className='container'>
          <h2 className='releases-hero-title'>{intl.formatMessage({id: 'RELEASES_HERO_TITLE'})}</h2>
          <p className='releases-hero-subtitle'>
            {intl.formatMessage({id: 'RELEASES_HERO_SUBTITLE'})}
          </p>
          <Link
            to='/auth/login'
            className='btn btn-outline btn-primary-deep darker hover-orange fs-4 fw-boldest text-capitalize rounded-pill py-3 px-6 releases-hero-btn'
          >
            {intl.formatMessage({id: 'EXPLORE_SHIPBAE'})}
          </Link>
        </div>
      </section>

      <div className='releases-content-wrapper'>
        <Outlet />
        <StartFreeToday />
      </div>
    </PublicWrapper>
  )
}
